import React from 'react';
import { Navigate, Outlet, Route } from 'react-router';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import MyEventsPageRoute from './MyEventsPageRoute';

const basePath = '/v2/events/account';

export default (
  <Route
    path={basePath}
    element={
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    }
  >
    <Route index element={<Navigate replace to={`${basePath}/upcoming`} />} />
    <Route path={`${basePath}/upcoming`} element={<MyEventsPageRoute />} />
    <Route path={`${basePath}/upcoming/:status`} element={<MyEventsPageRoute />} />
    <Route path={`${basePath}/past`} element={<MyEventsPageRoute past />} />
    <Route path={`${basePath}/past/:status`} element={<MyEventsPageRoute past />} />
    <Route path="*" element={<ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />} />
  </Route>
);
